import { ActionButton } from './ActionButton';
import { DetailTranslationKeys } from '../../../api/models/TranslationKeys';
import { Utils } from '@lightningjs/sdk';
import { FavouriteAction } from '../../../Business/detail/actions/FavouriteAction';
import { AssetType } from '../../../api/models/Shared.types';

export class SharedFavouriteActionButton extends ActionButton {
  _init() {
    this.label =
      this._type === AssetType.CHANNEL
        ? this._backend.translations.forKey(DetailTranslationKeys.detail_favorite_channel)
        : this._backend.translations.forKey(DetailTranslationKeys.detail_favorite);
    this.actionHandler = new FavouriteAction(this._backend, this._id, this._type, this._adult, val => {
      this.favouriteState = val;
      this.labelState = val;
    });
  }

  set labelState(val) {
    if (this._type === AssetType.CHANNEL) {
      this.label = val
        ? this._backend.translations.forKey(DetailTranslationKeys.detail_unfavorite_channel)
        : this._backend.translations.forKey(DetailTranslationKeys.detail_favorite_channel);
    } else {
      this.label = val
        ? this._backend.translations.forKey(DetailTranslationKeys.detail_unfavorite)
        : this._backend.translations.forKey(DetailTranslationKeys.detail_favorite);
    }
  }

  set favouriteState(val) {
    this._favstate = val;
    if (val === undefined || this._type === AssetType.CHANNEL) return;
    if (val) {
      this.iconRight = Utils.asset('images/guide/ic_star.png');
    } else {
      this.iconRight = Utils.asset('images/favorites/ic_star_open.png');
    }
  }

  set assetIsAdult(val) {
    this._adult = val;
  }

  set assetId(val) {
    this._id = val;
  }

  set assetType(val) {
    this._type = val;
  }
}
